import { AppConsts } from '@shared/AppConsts';
import { Component, Injector, ViewEncapsulation, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router, RouterLink } from '@angular/router';
import { NotifyService } from 'abp-ng2-module';
import { AppComponentBase } from '@shared/common/app-component-base';
import { StockTakeDto, StockTakeServiceProxy, TokenAuthServiceProxy, Status, CreateOrEditStockTakeDto, CreateOrEditStockTakeDetailDto, CreateOrEditPurchaseDetailDto, FindProductOutputDto, CommonLookupServiceProxy, CreateOrUpdateStockTakeDetailInput } from '@shared/service-proxies/service-proxies';
import { UtilsService } from 'app/shared/common/utils/utils-service';
import { appModuleAnimation } from '@shared/animations/routerTransition';
import { Table, TableModule } from 'primeng/table';
import { Paginator, PaginatorModule } from 'primeng/paginator';
import { LazyLoadEvent, PrimeTemplate } from 'primeng/api';
import { FileDownloadService } from '@shared/utils/file-download.service';
import { filter as _filter } from 'lodash-es';
import { DateTime } from 'luxon';

import { DateTimeService } from '@app/shared/common/timing/date-time.service';

import { ExcelColumnSelectionModalComponent } from '@app/shared/common/excel-column-selection/excel-column-selection-modal';
import { finalize } from 'rxjs';
import { EditStockItemModalComponent } from './edit-stock-item-modal.component';
import { stat } from 'fs';

@Component({
    templateUrl: './create-or-edit-stock-items.component.html',
    encapsulation: ViewEncapsulation.None,
    animations: [appModuleAnimation()],
    standalone: false,
})
export class CreateOrEditStockItemsComponent extends AppComponentBase {
    @ViewChild('editStockTakeDetailModal', { static: true })
    editStockTakeDetailModal: EditStockItemModalComponent;

    @ViewChild('dataTable', { static: true }) dataTable: Table;
    @ViewChild('paginator', { static: true }) paginator: Paginator;

    @ViewChild('excelColumnSelectionModal', { static: true })
    excelColumnSelectionModal: ExcelColumnSelectionModalComponent;
    stockTake: CreateOrEditStockTakeDto = new CreateOrEditStockTakeDto();
    stockTakeDetail: CreateOrEditStockTakeDetailDto = new CreateOrEditStockTakeDetailDto();
    advancedFiltersAreShown = false;
    filterText: '';
    status = Status;
    stockTakeId = 0;
    stockTakeHeaderinfo = '';
    scannedQty = 0;
    productSelectedItem: FindProductOutputDto;
    saving = false;
    constructor(
        injector: Injector,
        private _stockTakeServiceProxy: StockTakeServiceProxy,
        private _commonLookupServiceProxy: CommonLookupServiceProxy,
        private _notifyService: NotifyService,
        private _tokenAuth: TokenAuthServiceProxy,
        private _activatedRoute: ActivatedRoute,
        private _fileDownloadService: FileDownloadService,
        public utilsService: UtilsService,
        private _dateTimeService: DateTimeService,
    ) {
        super(injector);
    }
    
    getStockTakes(event?: LazyLoadEvent) {
        this.stockTakeId = this._activatedRoute.snapshot.queryParams['id'];
        if (this.primengTableHelper.shouldResetPaging(event)) {
            this.paginator.changePage(0);
            if (this.primengTableHelper.records && this.primengTableHelper.records.length > 0) {
                return;
            }
        }

        this.primengTableHelper.showLoadingIndicator();

        this._stockTakeServiceProxy.getStockTakeForEdit(this.stockTakeId).subscribe((data) => {
            this.stockTake = data.stockTake;
           
            this.stockTakeHeaderinfo = this.stockTake.stockTakeName + " - " + this.stockTake.stockTakeNo;
        });

        this._stockTakeServiceProxy
            .getStockTakeDetails(
                this.filterText,
                this.stockTakeId,
                this.primengTableHelper.getSorting(this.dataTable),
                this.primengTableHelper.getSkipCount(this.paginator, event),
                this.primengTableHelper.getMaxResultCount(this.paginator, event),
            )
            .subscribe((result) => {
                this.primengTableHelper.totalRecordsCount = result.totalCount;
                this.primengTableHelper.records = result.items;
                this.primengTableHelper.hideLoadingIndicator();
            });
    }

    clear() {
        this.stockTakeDetail = new CreateOrEditStockTakeDetailDto();
    }

    getScannedProduct(productId: number) {

        this._stockTakeServiceProxy
            .getStockDetailItem(this.stockTakeId, productId)
            .subscribe((result) => {
                this.scannedQty = result.physicalQty;
            });
    }


    searchProduct(productCode: string) {
        this._commonLookupServiceProxy
            .getProductDetail(undefined, productCode, undefined, 'Purchase', 0,this.appSession.user.locationId)
            .subscribe((result) => {
                if (result.productId > 0) {

                    this.stockTakeDetail.productId = result.productId;
                    this.stockTakeDetail.unitCost = result.unitCost;
                    this.stockTakeDetail.productName = result.productName;
                    this.stockTakeDetail.productCode = result.productCode;
                    this.stockTakeDetail.systemQty = result.qtyOnHand;
                    this.scannedQty = 0;
                    /*  data.applicableTaxes = result.applicableTaxes;*/
                    this.stockTakeDetail.unitName = result.unitName;
                    this.stockTakeDetail.unitId = result.unitId;


                    if (this.stockTakeDetail.productSelectedItem == null) {
                        this.stockTakeDetail.productSelectedItem = new FindProductOutputDto();
                        this.stockTakeDetail.productSelectedItem.id = result.productId;
                        this.stockTakeDetail.productSelectedItem.displayName = result.productName;
                        //this.productSelectedItem.code = result.productCode;
                    }
                    this.getScannedProduct(this.stockTakeDetail.productId);
                } else {
                    abp.notify.error('ProductNotFound');
                    this.stockTakeDetail.productCode = '';
                }
            });
    }

    getProduct(product: FindProductOutputDto) {
        this.productSelectedItem = product;
        this.stockTakeDetail.productSelectedItem = product;
        this.searchProduct(product.code);
    }

    reloadPage(): void {
        this.paginator.changePage(this.paginator.getPage());
    }

    createStockTake(): void {
        this.editStockTakeDetailModal.show();
    }

    save(): void {
        this.saving = true;
        var data = new CreateOrUpdateStockTakeDetailInput();
        data.stockTakeDetail = this.stockTakeDetail;
        data.stockTakeDetail.stockTakeId = this.stockTakeId;
        this._stockTakeServiceProxy
            .createOrEditStockTakeDetail(data)
            .pipe(
                finalize(() => {
                    this.saving = false;
                }),
            )
            .subscribe((x) => {
                this.saving = false;
                this.notify.info(this.l('SavedSuccessfully'));
                this.clear();
                this.getStockTakes();
            });
    }

    deleteStockTakeDetailItem(stockTake: any): void {
        console.log(stockTake);
        this.message.confirm('', this.l('AreYouSure'), (isConfirmed) => {
            if (isConfirmed) {
                this._stockTakeServiceProxy.deleteStockTakeDetailItem(stockTake.id).subscribe(() => {
                    this.reloadPage();
                    this.notify.success(this.l('SuccessfullyDeleted'));
                });
            }
        });
    }

    resetFilters(): void {
        this.getStockTakes();
    }

}
